import React from 'react';

function GamesSection() {
  return (
    <>
      <p>
        Jos sinulla on pelihostausoikeus, voit luoda tapahtuman jossa on peli. Pelityyppejä on tällä hetkellä neljä:
    </p>
        <ul>
          <li>Tietovisa</li>
          <li>ABCD-visa</li>
          <li>Arvoitus</li>
          <li>Emojit</li>
        </ul>
        <p>
        Joka tapahtuman jälkeen pelin eniten pisteitä 
        kerännyt osallistuja saa 20 krediittiä* palkintona sekä onnittelupostin 
         sisäiseen postilaatikkoonsa**.
        </p>
        <p>
        Joka tapahtuman jälkeen pelin toisiksi eniten pisteitä 
        kerännyt osallistuja saa 10 krediittiä* palkintona sekä onnittelupostin 
         sisäiseen postilaatikkoonsa**.
        </p>
        <p className='emphasis'>* Krediitit ovat sovelluksen sisäisiä pisteitä, joilla voi "ostaa" palveluita sovelluksen sisällä.</p>
      <p className='emphasis'>** Sovelluksen sisäisen postin avulla voit{':'}
        <ul>
        <li>lähettää ja vastaanottaa viestejä muilta käyttäjiltä.</li>
        <li>vastaanottaa tapahtuma-arviontiviestejä tapahtumajärjestäjiltä.</li>
        <li>vastaanottaa krediitit palkintona pelin jälkeen.</li>
        <li>vastaanottaa sovelluksen sisäisiä päivitysilmoituksia</li>
        </ul>
        </p>

    </>
  );
}

export default GamesSection;

